// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"e83be6a7","977":"02268014"}[chunkId] + ".chunk.js";
};